import { render, staticRenderFns } from "./EditSeguroincendioPage.vue?vue&type=template&id=1b6f7978&"
import script from "./EditSeguroincendioPage.vue?vue&type=script&lang=js&"
export * from "./EditSeguroincendioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports